export default __webpack_public_path__ + "static/media/blog05.107d5b01.png";